import { useAddRemoveQuery } from "@website/hooks/add-remove-query";
import { useRouter } from "next/router";
import { useCallback } from "react";

export const useDrawer = () => {
  const router = useRouter();
  const key = "HAMBURGER_MENU";
  const { [key]: isKey } = router.query;
  const { addQuery, removeQuery } = useAddRemoveQuery(key);

  const onDrawerOpen = useCallback(() => {
    addQuery("open");
  }, [addQuery]);

  const onDrawerClose = useCallback(() => {
    removeQuery();
  }, [removeQuery]);

  return {
    drawerIsOpen: Boolean(isKey),
    onDrawerOpen,
    onDrawerClose
  };
};
